// extracted by mini-css-extract-plugin
module.exports = {"container":"EmailVerificationContent_container__2mI5M"};